module.exports = __webpack_public_path__ + "img/log-point.75e39bae.svg";